var map = {
	"./BabyBee.png": 7777,
	"./BasicBee.png": 5661,
	"./BearBee.png": 618,
	"./BomberBee.png": 2110,
	"./BouyantBee.png": 5538,
	"./BraveBee.png": 5001,
	"./BubbleBee.png": 7478,
	"./BuckoBee.png": 4702,
	"./BumbleBee.png": 2934,
	"./CarpenterBee.png": 4205,
	"./CobaltBee.png": 7174,
	"./CommanderBee.png": 1324,
	"./CoolBee.png": 3975,
	"./CrimsonBee.png": 6122,
	"./DemoBee.png": 9985,
	"./DemonBee.png": 6779,
	"./DiamondBee.png": 6069,
	"./DigitalBee.png": 9983,
	"./EmptyHive.png": 3422,
	"./ExhaustedBee.png": 5596,
	"./FestiveBee.png": 5632,
	"./FireBee.png": 2662,
	"./FrostyBee.png": 2461,
	"./FuzzyBee.png": 2645,
	"./Gifted/BabyBee.png": 8566,
	"./Gifted/BasicBee.png": 596,
	"./Gifted/BearBee.png": 8713,
	"./Gifted/BomberBee.png": 3358,
	"./Gifted/BouyantBee.png": 1125,
	"./Gifted/BraveBee.png": 2802,
	"./Gifted/BubbleBee.png": 1004,
	"./Gifted/BuckoBee.png": 5428,
	"./Gifted/BumbleBee.png": 2035,
	"./Gifted/CarpenterBee.png": 4933,
	"./Gifted/CobaltBee.png": 9598,
	"./Gifted/CommanderBee.png": 4871,
	"./Gifted/CoolBee.png": 6387,
	"./Gifted/CrimsonBee.png": 7944,
	"./Gifted/DemoBee.png": 7252,
	"./Gifted/DemonBee.png": 510,
	"./Gifted/DiamondBee.png": 1006,
	"./Gifted/DigitalBee.png": 2834,
	"./Gifted/ExhaustedBee.png": 70,
	"./Gifted/FestiveBee.png": 7784,
	"./Gifted/FireBee.png": 9544,
	"./Gifted/FrostyBee.png": 8334,
	"./Gifted/FuzzyBee.png": 387,
	"./Gifted/GummyBee.png": 6108,
	"./Gifted/HastyBee.png": 5010,
	"./Gifted/HoneyBee.png": 9918,
	"./Gifted/LionBee.png": 2010,
	"./Gifted/LookerBee.png": 9555,
	"./Gifted/MusicalBee.png": 6014,
	"./Gifted/NinjaBee.png": 3183,
	"./Gifted/PhotonBee.png": 4454,
	"./Gifted/PreciseBee.png": 8084,
	"./Gifted/PuppyBee.png": 8209,
	"./Gifted/RadBee.png": 8304,
	"./Gifted/RageBee.png": 9535,
	"./Gifted/RascalBee.png": 5893,
	"./Gifted/RileyBee.png": 5193,
	"./Gifted/ShockedBee.png": 4711,
	"./Gifted/ShyBee.png": 8226,
	"./Gifted/SpicyBee.png": 1459,
	"./Gifted/StubbornBee.png": 341,
	"./Gifted/TabbyBee.png": 7988,
	"./Gifted/TadpoleBee.png": 3723,
	"./Gifted/VectorBee.png": 1643,
	"./Gifted/ViciousBee.png": 4144,
	"./Gifted/WindyBee.png": 9444,
	"./GummyBee.png": 3850,
	"./HastyBee.png": 6613,
	"./HoneyBee.png": 8495,
	"./LionBee.png": 3999,
	"./LookerBee.png": 5063,
	"./MusicalBee.png": 8631,
	"./NinjaBee.png": 426,
	"./PhotonBee.png": 1902,
	"./PreciseBee.png": 4904,
	"./PuppyBee.png": 879,
	"./RadBee.png": 4595,
	"./RageBee.png": 6787,
	"./RascalBee.png": 2613,
	"./RileyBee.png": 2755,
	"./ShockedBee.png": 109,
	"./ShyBee.png": 640,
	"./SpicyBee.png": 2303,
	"./StubbornBee.png": 8118,
	"./TabbyBee.png": 1202,
	"./TadpoleBee.png": 2355,
	"./VectorBee.png": 6278,
	"./ViciousBee.png": 3985,
	"./WindyBee.png": 5303
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8313;